import React, { useState } from "react";
import SectionTitle from "../../elements/section-title/SectionTitle";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { ProjectSecondData } from "./ProjectSecondData";

const AllData = [...ProjectSecondData];

const ProjectTwo = ({
  portfolio1103,
  parentClass,
  colSize,
  itemShow,
  columnGap,
}) => {
  const [getAllItems] = useState(AllData);

  const carouselProjects = getAllItems;

  const slickSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    autoplay: true,
    centerPadding: '20%',
    autoplaySpeed: 2000,
    arrows: false,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: '15%',
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: '10%',
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: '5%',
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: '0%',
        }
      }
    ]
  };

  return (
    <>
      <div
        className={`section section-padding-2 ${parentClass ? parentClass : ""
          }`}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div>
                <SectionTitle
                  subtitle="Our Project"
                  title="Few of our <br>
                        finest works."
                  description=""
                  textAlignment="heading-left mb--40"
                  textColor=""
                  paragraphClass="description-Width"
                />
                <div className="banner pt-0" style={{ minHeight: "fit-content" }}>
                  <div className="banner-content">
                    <button className="zoom_animation border-0 bg-white px-0">
                      <Link
                        to={process.env.PUBLIC_URL + "/portfolio"}
                        className="axil-btn btn-fill-primary btn-large px-5 py-3"
                      >
                        View All
                      </Link>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-7">
              <div className="isotope-button isotope-project-btn mb-0">
                <div className="project-carousel">
                  <Slider
                    {...slickSettings}
                    cssEase="linear"
                    rtl={false}
                    className="overlapping-carousel">
                    {carouselProjects.map((project) => (
                      <div key={project.id} className="project-slide pe-0">
                        <div className="project-carousel-card">
                          <Link className="w-100" to={`${process.env.PUBLIC_URL}/Portfolio-project-details/${project.id}`}>
                            <div className="project-image-container h-100 w-100">
                              <img
                                src={process.env.PUBLIC_URL + project.img}
                                alt={project.title}
                                className="w-full rounded"
                                loading="lazy"
                                width="800"
                                height="800"
                              />
                              {/* <div className="project-overlay">
                                <h4 className="text-white font-bold text-xl">{project.title}</h4>
                                <p className="text-white">{project.category.join(', ')}</p>
                              </div> */}
                            </div>
                          </Link>
                        </div>
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>
            </div>
          </div>


        </div>
        <ul className="shape-group-7 list-unstyled">
          <li className="shape shape-1">
            <img
              src={process.env.PUBLIC_URL + "/images/others/circle-2.png"}
              alt="circle"
              loading="lazy"
              width="886"
              height="888"
            />
          </li>
          <li className="shape shape-2">
            <img
              src={process.env.PUBLIC_URL + "/images/others/bubble-2.png"}
              alt="Line"
              loading="lazy"
              width="150"
              height="150"
            />
          </li>
          <li className="shape shape-3">
            <img
              src={process.env.PUBLIC_URL + "/images/others/bubble-1.png"}
              alt="Line"
              loading="lazy"
              width="88"
              height="88"
            />
          </li>
        </ul>
      </div>
    </>
  );
};

export default ProjectTwo;
